import { LoginWrapper } from 'components/views/pages/login/LoginWrapper';
import { LoginModeEnum } from 'components/views/pages/login/types';

const LoginGuest = () => {
  return <LoginWrapper mode={LoginModeEnum.guest} />;
};

export default LoginGuest;
